import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './HeaderTemplate.styles'
import { StandFirst } from 'components/ui/Typography/StandFirst'
import clsx from 'clsx'
import { IBanner } from '../../shared/types'
import { useBreakpoint } from 'store/navigation/hooks/useBreakpoint'

export interface IHeader {
  banner: IBanner
  className?: string
  standFirst?: string
}

export const HeaderTemplate = ({ className, standFirst, banner }: IHeader) => {
  const classes = useStyles()
  const breakPoint = useBreakpoint()
  const isMobile = breakPoint === 'xs'
  const { title, image } = banner

  const backgroundUrl = isMobile ? image?.urlMobile : image?.urlDesktop
  return (
    <>
      <header className={classes.header}>
        <Grid className={classes.background} style={{ backgroundImage: `url(${backgroundUrl})` }}>
          <p className={classes.title}>{title}</p>
        </Grid>
      </header>
      {standFirst && (
        <Grid className={clsx(className, classes.standFirst)}>
          <StandFirst text={standFirst} />
        </Grid>
      )}
    </>
  )
}
